import React from "react";
import {
  ArrayField,
  ChipField,
  Datagrid,
  DateField,
  List,
  ReferenceInput,
  SelectInput,
  SingleFieldList,
  TextField
} from "react-admin";

const FormsAvailabilityList = (props) => {
    const filters = [
      <ReferenceInput
        source="classId"
        reference="classes"
        perPage={9999}
        label={'Turma'}
      >
        <SelectInput emptyText={'Todas'} source="name" optionText={record => record.name} />
      </ReferenceInput>,
      <ReferenceInput
        source="formId"
        reference="forms"
        perPage={9999}
        label={'Formulário'}
        filter={{ academic_period: 'current' }}
      >
        <SelectInput emptyText={'Todos'} source="name" optionText={record => record.name} />
      </ReferenceInput>,
      <SelectInput
        label="Vigencia"
        source="active"
        emptyValue={"all"}
        choices={[
          { name: "Vigente", id: "current" },
          { name: "Vencidos", id: "expired" },
          { name: "Todos", id: "" },
        ]}
        alwaysOn
      />,
    ]
    return (
        <List exporter={false} bulkActionButtons={false}
            title={'Disponibilidade de Formulários'}
            {...props}
            filters={filters}
              filterDefaultValues={{ active: 'current'}}
        >
            <Datagrid rowClick={'edit'} >
                <TextField source="form.name" label={'Formulário'} />
                <ArrayField source={'classes'} label={'Turmas'} sortable={false}>
                  <SingleFieldList linkType={false}>
                    <ChipField source='name' />
                  </SingleFieldList>
                </ArrayField>
                <ArrayField source={'owners'} label={'Responsáveis'} sortable={false}>
                  <SingleFieldList linkType={false}>
                    <ChipField source='name' />
                  </SingleFieldList>
                </ArrayField>
                <DateField source="start" label={'Data Inicial'} />
                <DateField source="end" label={'Data Final'} />
            </Datagrid>
        </List>
    )
}

export default FormsAvailabilityList;